import lisa from '../../assets/img/lisa.png';
import shinyZH from '../../assets/img/shiny.png';
import MPC from '../../assets/img/isla_500x500.54939114_c40i6j8i.webp';
import OldCV from '../../assets/img/oldcv.jpeg'
import ShinyLeaflet from '../../assets/img/shinyLeaflet.png'
import Angers from '../../assets/img/Angers.png'
import Spectrum from '../../assets/img/Spectrum.png'
import Regex from '../../assets/img/Regex.png'
import API from '../../assets/img/API.png'
import OSCAR from '../../assets/img/OSCAR.png'


export const RealisationsData = [
    {
        "id": 1,
        "src": Angers,
        "caption": "Beautiful Map Designer",
        "href": "https://pretty-buffered-city-maps.streamlit.app/"
    },
    {
        "id": 2,
        "src": Spectrum,
        "caption": "Pokedata Jrose 11 (statistiques pokemon)",
        "href": "https://pokedata-jrose11.streamlit.app/"
    },
    {
        "id": 3,
        "src": Regex,
        "caption": "Just a regex tool",
        "href": "https://just-a-regex-tool.streamlit.app/"
    },
    {
        "id": 4,
        "src": OSCAR,
        "caption": "OSCAR Outil-s-quentiel-de-correction-automatique-de-Refsite",
        "href": "https://github.com/Guimill/OSCAR---Outil-s-quentiel-de-correction-automatique-de-Refsite"
    },
    {
        "id": 5,
        "src": API,
        "caption": "API---Automatic-PIT-Importer",
        "href": "https://github.com/Guimill/API---Automatic-PIT-Importer"
    },
    {
        "id": 6,
        "src": ShinyLeaflet,
        "caption": "Cartographie de la population francaise par departement en 2023",
        "href": "https://milleretg4progress.shinyapps.io/R-leaflet-Fr-pop-data/"
    },
    {
        "id": 7,
        "src": shinyZH,
        "caption": "Synthetiseur de fonctionnalites des zones humides",
        "href": "https://milleretg4progress.shinyapps.io/shinyapps/"
    },
    {
        "id": 8,
        "src": lisa,
        "caption": "The Simpsons Politiscale - (HS - bd déconnecté)",
        "href": "https://the-simpsons-politiscales.fr/"
    },
    {
        "id": 9,
        "src": MPC,
        "caption": "Mon petit coton - En cours",
        "href": "https://mon-petit-coton.netlify.app/gallery"
    },
    {
        "id": 10,
        "src": OldCV,
        "caption": "Ancien CV",
        "href": "https://www.linkedin.com/in/guillaume-milleret/"
    }
]
